<template>
  <div
    tabindex="0"
    role="menuitem"
    class="menu-item"
    :class="{ active: toolbar?.selected === id }"
    @click="select"
  >
    <component :is="icon" class="icon max-w-7 max-h-7" :class="{ highlighted }" />
    <span class="text-pane-label">{{ label }}</span>
  </div>
  <Teleport v-if="toolbar?.selected === id" to="#toolbar-pane">
    <slot />
  </Teleport>
</template>

<script lang="ts" setup>
import type { VueInstance } from '@vueuse/core';
import type { FunctionalComponent } from 'vue';
import { useToolbar } from './injects';

interface Props {
  id: string;
  label: string;
  title: string;
  icon: VueInstance | FunctionalComponent;
  highlighted?: boolean;
}

const props = defineProps<Props>();
const toolbar = useToolbar();

const select = () => {
  toolbar?.select?.(props);
};
</script>

<style lang="scss" scoped>
.menu-item {
  @apply flex flex-col items-center gap-y-1;
  @apply px-3 py-3.5 cursor-pointer;
  @apply hover:bg-info-blue-10 hover:text-info-blue;
  @apply transition-colors;
  @apply font-normal text-dark;

  width: var(--menu-width);

  .icon.highlighted :deep(path) {
      @apply fill-info-blue;
  }

  &.active {
    @apply text-pane-label-active;
    @apply bg-info-blue-10 text-info-blue;

    :deep(svg path) {
      @apply fill-info-blue;
    }
  }

  :deep(svg path) {
    @apply transition-all;
  }

  &:hover :deep(svg path) {
    @apply fill-info-blue;
  }
}
</style>
